import styled from "styled-components";

export const SearchBar = styled.input`
    width: 50%;
    padding: 5px 10px;
    border-radius: 7px;
    
    @media (max-width: 680px){
        width: 80%;
    }
`

